// Compresses a sorted list of episode indices into a compact display string.
// e.g. [1,2,3,5] → "EP01-03, EP05". Used on asset cards where horizontal space
// is tight and per-episode chips would overflow.
export function formatEpisodeRange(episodes: readonly number[]): string {
  if (!episodes || episodes.length === 0) {
    return '';
  }

  const sorted = [...episodes].sort((a, b) => a - b);
  const segments: string[] = [];
  let start = sorted[0];
  let prev = start;

  const pad = (n: number): string => String(n).padStart(2, '0');
  const flush = () => {
    segments.push(start === prev ? `EP${pad(start)}` : `EP${pad(start)}-${pad(prev)}`);
  };

  for (let i = 1; i < sorted.length; i++) {
    const n = sorted[i];
    // Skip duplicates to keep the output clean even if upstream sends dupes.
    if (n === prev) {
      continue;
    }
    if (n === prev + 1) {
      prev = n;
      continue;
    }
    flush();
    start = n;
    prev = n;
  }
  flush();
  return segments.join(', ');
}
